import { getRandomNumber } from './random-number';

export const getRandomTime = (date: Date): Date => {
  let newTime = new Date(date);
  newTime.setHours(getRandomNumber(0, 23));
  newTime.setMinutes(getRandomNumber(0, 59));
  newTime.setSeconds(0);
  newTime.setMilliseconds(0);
  return newTime;
};
